import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "primitive-data-types"
    }}>{`Primitive Data Types`}</h1>
    <p>{`This page describes data types whose definitions may not be commonly recognized. Unless otherwise stated, these are expressed as strings in the JSON content traversing the Lightroom APIs.`}</p>
    <h3 {...{
      "id": "lowercase-uuid"
    }}>{`Lowercase UUID`}</h3>
    <p>{`A `}<a target="new" href="http://en.wikipedia.org/wiki/Universally_unique_identifier">{` universally-unique identifier`}</a>{` where the hex digits are represented using lower case letters and the hyphens are omitted. Used to identify virtually all objects in the Lightroom cloud.`}</p>
    <h3 {...{
      "id": "user-visible-string"
    }}>{`User-visible string`}</h3>
    <p>{`A `}<em parentName="p">{`user-visible string`}</em>{` is interpreted to mean any string that is valid in JSON, with the following exceptions:`}</p>
    <ul>
      <li parentName="ul">{`UTF8 encoding is expected.`}</li>
      <li parentName="ul">{`Unicode control characters (including CR, LF, tab) are disallowed.`}</li>
      <li parentName="ul">{`Clients are expected to display these as user-visible strings without further interpretation. Clients are responsible for escaping strings to prevent unwanted interpretations.`}</li>
      <li parentName="ul">{`This is specifically `}<em parentName="li">{`not`}</em>{` formatted HTML. Any HTML markup that might be entered into the string should `}<em parentName="li">{`not`}</em>{` cause the corresponding HTML formatting to occur. Clients are responsible for escaping characters such as <, >, and & to prevent browser side effects.`}</li>
      <li parentName="ul">{`User-visible strings must be non-empty.`}</li>
      <li parentName="ul">{`Some of these restrictions might be overridden in specific cases.`}</li>
    </ul>
    <h3 {...{
      "id": "iso-8601-date-stamps"
    }}>{`ISO 8601 date stamps`}</h3>
    <p>{`An ISO 8601 date stamp, unless otherwise specified, is a timestamp in the `}<a parentName="p" {...{
        "href": "http://www.w3.org/TR/NOTE-datetime"
      }}>{`W3C-specific subset of the ISO 8601 format`}</a>{`.`}</p>
    <ul>
      <li parentName="ul">{`Timestamps intended for sorting should be specified in UTC and include the trailing "Z" indicator of such. Clients should use the closest available approximation of UTC. The Lightroom server will always use a highly-accurate UTC time.`}</li>
      <li parentName="ul">{`Timestamps intended for user display and grouping (especially date-based grouping) should use local timestamps and include an appropriate designator of the actual time zone.`}</li>
    </ul>
    <h4 {...{
      "id": "cleansing-invalid-datetime-values"
    }}>{`Cleansing Invalid Datetime Values`}</h4>
    <p>{`The datetime values provided by clients in some model payloads have validation rules. A datetime might come from metadata generated by a camera or a third party application which may be using nonstandard formatting that does not pass the validation rules. It is recommended that clients check payload values for validity before sending the data to the cloud. Specifically for datetime values, if the value does not pass validation it is recommended that clients attempt some simple fixes to the datetime to retain as much information as possible and to get to a valid value.`}</p>
    <p>{`Validating dates locally before sending to the cloud is preferred. If the cloud rejects a date as invalid, it is recommended to remove the date or come up with a suitable replacement for required dates as detailed below, in order to avoid bugs involving confusion and disagreement between the cloud and client on the correct values, which sometimes triggers looping behavior where the client attempts to send the same data to the cloud repeatedly, in some cases thousands of times.`}</p>
    <ul>
      <li parentName="ul">{`If the seconds value is 60, indicating a possible leap second, convert it to 59`}
        <ul parentName="li">
          <li parentName="ul">{`e.g. 2017-03-09T15:47:60.000Z becomes 2017-03-09T15:47:59.000Z`}</li>
        </ul>
      </li>
      <li parentName="ul">{`Try removing the time and submitting the date only.`}
        <ul parentName="li">
          <li parentName="ul">{`Most datetime values in the data model require time, so a client would need to replace the time with 00:00:00 (e.g. 2017-03-09T00:00:00)`}</li>
          <li parentName="ul">{`Many times do not require timezone, but some times require a valid timezone and some specifically require GMT timezone with a Z timezone specification (e.g. 2017-03-09T00:00:00Z). For all times requiring a time zone, the recommendation is to specify GMT (Z) timezone.`}</li>
          <li parentName="ul">{`Most datetimes in the xmp section of the asset payload allow date only (e.g. 2017-03-09)`}</li>
        </ul>
      </li>
      <li parentName="ul">{`If the date is invalid, then a client will need to omit the field or come up with a suitable replacement for required fields.`}
        <ul parentName="li">
          <li parentName="ul">{`The required field captureDate in the asset payload allows the special value 0000-00-00T00:00:00 for assets with unknown capture date.`}</li>
          <li parentName="ul">{`The only other strictly required fields for assets is importSource.importTimestamp, and current time can be substituted for that value.`}</li>
        </ul>
      </li>
    </ul>
    <h3 {...{
      "id": "reasonable-filefolder-path-name"
    }}>{`Reasonable file/folder path name`}</h3>
    <p>{`A reasonable file or folder path is a UTF-8 string designed to comply with the typical file naming rules on MacOS and Windows without unexpected side effects.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      